import { isEditModeActive } from "./sanity-client";

document.addEventListener("DOMContentLoaded", () => {
    // Check if we are on the SaaS case study page
    const content = document.getElementById("case-study-content");
    if (content && content.getAttribute("data-title") === "SaaS application for an Ad-tech startup") {
        if (isEditModeActive()) {
            console.log("Edit mode is active for SaaS application case study");
        }
    }
});
